import React, { Fragment } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import "./style.css";
import { themeService } from "../../theme/service/activeTheme.service";
import { ButtonStyle } from "../../style/basic/commonControls";
import PropTypes from "prop-types";
import { languageService } from "../../Language/language.service";
export const confirmationDialogWarningMessage = (message) => {
  return <b className="confirmation-dialog-warning-message">{message}</b>;
};
      /**
* Renders a user-friendly Confirmation Dialog bar in single line with the type and message separated by a colon ':'
* @param {bool} props.modal -The boolean to show or hide the modal.
* @param {func} props.toggle - A function for the toggling of the modal
* @param {string} props.className -  CSS class to apply styling to the modal.
* @param {func} props.maxHeight -  Whether to set the tooltip's max-height to 100%.
* @param {string} props.headerText - A header text to show in modal header.
* @param {string} props.confirmationMessage - A confirmation message for modal whether to confirm or not.
* @param {string} props.handleResponse - A function confirm or cancel the modal.
* @returns {JSX.Element} rendered component
*/
const ConfirmationDialog = ({ title, body, confirmButtonLabel, cancelCallback, confirmationCallback, action, additionalInfo }) => {
  const callback = () => {
    confirmationCallback && confirmationCallback(action, additionalInfo);
  }

  return (
    <Fragment>
      <Modal className={"confirmation-dialog"} isOpen={true}>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>{body}</ModalBody>
        <ModalFooter>
          <Button onTouchEnd={callback} onClick={callback} style={themeService(ButtonStyle.commonButton)}>
            {confirmButtonLabel ? confirmButtonLabel : languageService("Confirm")}
          </Button>
          <Button onTouchEnd={cancelCallback} onClick={cancelCallback} style={themeService(ButtonStyle.commonButton)}>
            {languageService("Cancel")}
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

export default ConfirmationDialog

export const OpenConfirmationDialog = ({ title, message, displayAddInfo, action, confirmCallback, additionalInfo, cancelCallback }) => {
  return (
    <ConfirmationDialog
      title={title}
      body={
        <Fragment>
          <div>{`${message}`}</div>
          {displayAddInfo}
        </Fragment>
      }
      action={action}
      cancelCallback={cancelCallback}
      confirmationCallback={confirmCallback}
      additionalInfo={additionalInfo}
    />
  );
};
ConfirmationDialog.prototype={
    modal: PropTypes.bool.isRequired,
    toggle: PropTypes.func,
    className: PropTypes.string,
    headerText: PropTypes.string.isRequired,
    confirmationMessage: PropTypes.string.isRequired,
    handleResponse: PropTypes.func.isRequired

}




// WEBPACK FOOTER //
// ./src/libraries/ConfirmationDialog/index.jsx